import React, { useEffect, useRef, useState } from 'react'
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useHistory, useParams } from 'react-router-dom';
import { endPoints } from '../../config/end-points';
import useHttp from '../../hooks/use-http';
import ReactTooltip from "react-tooltip";
import { authActions } from '../../store/auth';
import { cuteToast } from '../UI/cute';
import NotFound from './404';
import PreviewTemplate from "../shared/modals/PreviewTemplate";

const AllTemplates = () => {

    const [showTemplate, setShowTemplate] = useState(false);
    const [templateDetail, setTemplateDetail] = useState();
    const userAccess = useSelector((state) => state.auth.access);

    const { page_no } = useParams();
    const { sendRequest } = useHttp();
    
    const [templates, setTemplates] = useState([]);
    const [count, setCount] = useState();
    const [search, setSearch] = useState();
    
    const [load ] = useState(1);
    const ref = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
  
    var options = {
      weekday: "short", //long
      year: "numeric",
      month: "short", //long
      day: "numeric",
    };
  
    useEffect(() => {
      document.title = `${endPoints.title} | All Templates`;
    });
    useEffect(() => {
      const responseData = (response) => {
        // console.log(response)
        if(response.status === 200){
          if (response.totalPages > 0 && response.content.length === 0) {
            history.push("/alltemplates");
          }
  
          setTemplates(response.content);
          setCount(response.totalPages);
          dispatch(authActions.setLoaderStatus({ status: false }));
        }else{
          
          dispatch(authActions.setLoaderStatus({ status: false }));
          history.push("/404");
        }
      };
  
      const page = page_no ? page_no : "";
      const url =
        endPoints.getAllTemplates + "/" + page + (search ? "?search=" + search : "");
      sendRequest({ url: url, method: "GET" }, responseData);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page_no, search, load]);

    const handlePageChange = ({ selected }) => {
      if (selected === 0) {
        history.push("/alltemplates");
      } else {
        history.push("/alltemplates/" + selected);
      }
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      setSearch(ref.current.value);
    };
  
    const previewTemplate = (e, template_id) => {
      const templateData = templates.find((template) => template.id === template_id);
      setTemplateDetail(templateData);
      console.log(templateData);
      setShowTemplate(true)
    };
    
  
    const handleAvtivateTemplate = (e, template_id, status) => {
      e.preventDefault();
      
      sendRequest(
        { url: endPoints.activateTemplate, method: "POST", body: { template_id,status } },
        (response) => {
          console.log(response);
          // setIsload(parseInt(load) + 1);
          const templatesall = templates.map((template) => {
            if (template.id === template_id) {
              template.status = response.status;
            }
            return template;
          });
          setTemplates(templatesall);

          if(response.status === 1){
            cuteToast({
              type: "success",
              message: "Template Activated!",
              timer: 5000,
              title: "Activated",
            });
          }else{
            cuteToast({
              type: "error",
              message: "Template Deactivated!",
              timer: 5000,
              title: "Deactivated",
            });
          }

        }
      );
    };

      /*
    Rebuild or re-init React-tooltip 
    */
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    return (
      <>
        <ReactTooltip />
        {(userAccess.includes("5") || userAccess.includes("9S")) ? (
            <section className="mid_wrap">
            <div className="container">
              <div className="row align-items-center mb-4 pb-4">
                <div className="col-6">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <a href="#0">Dashboard</a>
                      </li>
                      <li className="breadcrumb-item active">All Templates</li>
                    </ol>
                  </nav>
                </div>
  
                <div className="col-6 d-flex">
                  <NavLink className="btn ms-auto" to="/create-template">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/plus.png`}
                      alt="img"
                    />{" "}
                    Create New
                  </NavLink>
                </div>
              </div>
              <div className="row mb-5">
                <div className=" col-xl-5 col-lg-5 col-md-12 m-auto">
                  <div className="search_form2 position-relative">
                    <form onSubmit={handleSubmit}>
                      <input
                        name=""
                        type="text"
                        className=" form-control"
                        placeholder="Enter Template Name"
                        ref={ref}
                      />
                      <input
                        name=""
                        type="submit"
                        value="Search"
                        className="btn"
                      />
                    </form>
                  </div>
                </div>
              </div>
              <div className="p_bx ovr_auto mb-5">
                <table
                  className="table usertable"
                  width="100%"
                  cellSpacing="0"
                  cellPadding="0"
                  border="0"
                >
                  <thead>
                    <tr>
                      <th>Template Name</th>
                      <th>Product</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {templates.length > 0 &&
                      templates.map((template) => {
                        return (
                          <tr valign="middle" key={template.id}>
                            <td>{`${template.name}`}</td>
                            <td>{`${template.type}`}</td>
                            <td
                              className={`${
                                template.status === 1 ? "text-success" : "text-danger"
                              }`}
                            >
                              {template.status === 1 ? "Active" : "InActive"}
                            </td>
                            <td>
                              {new Date(template.createdAt).toLocaleDateString(
                                "en-US",
                                options
                              )}
                            </td>
                            <td>
                              {new Date(template.updatedAt).toLocaleDateString(
                                "en-US",
                                options
                              )}
                            </td>
                            <td>
                              <div className=" link_vd ">
                                <ul>
                                  <li>
                                    <Link 
                                        to={`/template/edit/${template.id}`}
                                        data-effect="solid"
                                        data-tip="Edit"
                                      >
                                      
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/edit.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </Link>
                                  </li>
                                  {template.status !== 2 && (
                                    <li>
                                      
                                    </li>
                                  )}
  
                                  { (
                                    <li>
                                      <a
                                        href="#0"
                                        onClick={(e) =>
                                          handleAvtivateTemplate(e, template.id, template.status)
                                        }
                                        data-effect="solid"
                                        data-type={template.status === 1 ? "success" : "error"}
                                        data-tip={template.status === 1 ? "Active" : "InActive"}
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/refresh.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/refresh_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                  )}

                                  { (
                                    <li>
                                      <a
                                        href="#0"
                                        onClick={(e) =>
                                          previewTemplate(e, template.id)
                                        }
                                        data-effect="solid"
                                        data-tip="Preview"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                  )}


  
                                  <li>  
                                    
                                  </li>
  
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    {templates.length === 0 && (
                      <tr>
                        <td colSpan={5}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {count > 0 && (
                <nav aria-label="...">
                  <ReactPaginate
                    previousLabel={"<<"}
                    nextLabel={">>"}
                    breakLabel="..."
                    breakLinkClassName={"page-link"}
                    pageCount={count}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    activeClassName={"active"}
                    previousClassName={"page-item"}
                    nextClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"d-none"}
                    initialPage={page_no ? parseInt(page_no) : ""}
                  />
                </nav>
              )}
            </div>
          </section>
          
        ) : (
            <NotFound />
        )}

        {showTemplate && (
          <>
            <PreviewTemplate
              setShowTemplate={setShowTemplate}
              thumbnail_url={templateDetail.thumbnail_url}
              preview_url={templateDetail.preview_url}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </>
    );
}

export default AllTemplates;